var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInprocess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2914",
    "data-name": "Group 2914",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Widget_Illustration",
    "data-name": "Icons / Widget Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-sessions"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    fill: "#c3d2ea",
    stroke: "#6b8cc1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(16.722 16.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M0,0H21.122V21.122H0Z",
    fill: "none"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M8.517,17.437a7.347,7.347,0,1,1,7.346,7.346A7.355,7.355,0,0,1,8.517,17.437Zm1.29,0a6.057,6.057,0,1,0,6.056-6.059A6.063,6.063,0,0,0,9.807,17.437Zm-.225,7.346H.984a.915.915,0,0,1-.86-.406A1.176,1.176,0,0,1,0,23.784L.04.965A.754.754,0,0,1,.182.32.9.9,0,0,1,.851,0H15.59a.663.663,0,0,1,.464.181l4.3,4.2a.647.647,0,0,1,.208.49v4.3a.671.671,0,1,1-1.341-.024v-4L15.311,1.338H1.4V23.443H9.582a.687.687,0,0,1,.669.669.672.672,0,0,1-.588.667l0,0Zm4.4-4.267a.546.546,0,0,1-.079-.076,3.342,3.342,0,0,1-.707-1.144.549.549,0,0,1,1.036-.366,2.248,2.248,0,0,0,.469.75,2.6,2.6,0,0,0,1.949.559,2.526,2.526,0,1,0-1.93-4.31s-.008.007-.013.012l-.573.538h.662a.551.551,0,1,1,0,1.1h-2.05a.55.55,0,0,1-.241-.055l0,0,0,0a.569.569,0,0,1-.15-.115A.547.547,0,0,1,12.2,17V14.979a.55.55,0,0,1,1.1,0v.779l.654-.612a3.625,3.625,0,1,1,2.764,6.19c-.117.007-.227.01-.337.01A3.628,3.628,0,0,1,13.98,20.516ZM4.016,14.668a.744.744,0,0,1,0-1.488H7.651a.746.746,0,0,1,.746.743.769.769,0,0,1-.77.745ZM4.042,11.5a.744.744,0,1,1,0-1.488H9.854a.744.744,0,0,1,0,1.488Zm-.05-3.067a.744.744,0,0,1,0-1.488h9.916a.744.744,0,0,1,0,1.488Zm.05-2.991a.744.744,0,1,1,0-1.488h9.917a.744.744,0,0,1,0,1.488Z",
    transform: "translate(17.391 15.61)",
    fill: "#2a4a7c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprocess);
export default __webpack_public_path__ + "static/media/inprocess.9d94310673a7bf959b010368ffeef968.svg";
export { ForwardRef as ReactComponent };